export default{
    apiKey: "AIzaSyABoRLpOqrciYq8mAwfFHpims3wzecLxhU",
    authDomain: "helloapp-87353.firebaseapp.com",
    databaseURL: "https://helloapp-87353.firebaseio.com",
    projectId: "helloapp-87353",
    storageBucket: "helloapp-87353.appspot.com",
    messagingSenderId: "56199051359",
    appId: "1:56199051359:web:988e8f2f12e8a4355d03ea"
};
